import keyBy from 'lodash/keyBy'

import {CoreState} from '../redux/features/core'

import {Permission, ProviderId} from '../types'

import * as colorApi from './api/color'
import * as countryApi from './api/country'
import * as finishGroupApi from './api/finish-group'
import * as materialApi from './api/material'
import * as materialConfigApi from './api/material-config'
import * as materialGroupApi from './api/material-group'
import * as printingMethodApi from './api/printing-method'
import * as providerApi from './api/provider'

export default async (
  permission: Permission,
  providerId: ProviderId
): Promise<Partial<CoreState>> => {
  const [
    materialConfigs,
    colors,
    finishGroups,
    materials,
    materialGroups,
    provider,
    countries,
    printingMethods,
  ] = await Promise.all([
    materialConfigApi.getByDefaultOrder(),
    colorApi.get(),
    finishGroupApi.getByDefaultOrderWithTags(),
    materialApi.getByDefaultOrderWithTagsAndPrintingMethods(),
    materialGroupApi.get(permission),
    providerApi.getById(providerId),
    countryApi.get(),
    printingMethodApi.get(),
  ])

  // Verification: only use materials which have at least one finishGroup
  const filteredMaterials = materials.filter(material =>
    finishGroups.find(finishGroup => finishGroup.materialId === material.id)
  )

  return {
    materialConfigs: keyBy(materialConfigs, materialConfig => materialConfig.id),
    colors: keyBy(colors, color => color.id),
    finishGroups: keyBy(finishGroups, finishGroup => finishGroup.id),
    materials: keyBy(filteredMaterials, material => material.id),
    materialGroups: keyBy(materialGroups, materialGroup => materialGroup.id),
    provider,
    countries: keyBy(countries, country => country.code),
    printingMethods: keyBy(printingMethods, printingMethod => printingMethod.id),
  }
}
